export default function Hero() {
  return (
    <section
      id="home"
      className="relative w-full h-[90vh] min-h-[600px] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <img
        src="https://public.readdy.ai/ai/img_res/fbfcd8e8e3462b4adfbb24f1795eddf6.jpg"
        alt="NRG Trading oil tanker"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0c1f38]/85 via-[#0c1f38]/50 to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-4xl">
          <p className="text-[#d4571a] text-[77px] font-semibold tracking-widest uppercase mb-4">
            NRG Trading
          </p>
          <h1 className="text-white text-[41px] lg:text-[51px] font-bold leading-tight mb-6">
            Energising<br />Growth
          </h1>
          <p className="text-white/80 text-base lg:text-lg leading-relaxed mb-8 max-w-md">
            A global energy company — empowering people, nations, and businesses by responsibly trading and distributing energy.
          </p>

        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-8 bg-white/40" />
        <div className="w-4 h-4 flex items-center justify-center text-white/40">
          <i className="ri-arrow-down-s-line text-xl" />
        </div>
      </div>
    </section>
  );
}
